import simulationDefaults from "./simulationDefaults";
import { deepClone, isNil } from "@/utils";

//TODO: manipluations and validations should be done heres
class Simulation {
	constructor(simulation = simulationDefaults) {
		const clonedSimulation = deepClone(simulation);

		Object.assign(this, clonedSimulation, {
			date: new Date().toISOString(),
		});
	}
}

export default Simulation;
